<template>
	<div class="card-v2 card-account-info">
		<h2 class="mb-20">Account Information</h2>
		
		<!-- TODO: validation -->
		<div class="border pad-24">
			<h5 class="mb-8">My Information</h5>
			<div class="flex wrap gap-24">
				<div class="field-v2">
					<label for="firstName">First Name</label>
					<input v-model="form.account.firstName" type="text" id="firstName">
				</div>
				<div class="field-v2">
					<label for="lastName">Last Name</label>
					<input v-model="form.account.lastName" type="text" id="lastName">
				</div>
				<div v-if="isStudio" class="field-v2">
					<label for="studioName">Studio Name</label>
					<input v-model="form.profile.studioName" type="text" id="studioName">
				</div>
				<div class="field-v2">
					<label for="email">Email</label>
					<input v-model="form.account.email" type="email" id="email">
				</div>
			</div>
		</div>

		<!-- TODO: password show/hide, validation -->
		<div class="border pad-24 mt-16">
			<h5 class="mb-8">Update Password</h5>
			<div class="flex-top wrap gap-24">
				<div class="field-v2">
					<label for="password">Current Password</label>
					<PasswordFieldNew v-model="form.account.password" id="password"></PasswordFieldNew>
				</div>
				<div class="field-v2">
					<label for="newPassword">New Password</label>
					<PasswordFieldNew v-model="form.account.newPassword" id="newPassword" @blur="checkPasswordTooShort"></PasswordFieldNew>
					<small :class="{'color-red': passwordTooShort}" class="message">Your password must be 8 characters long.
						<svg v-if="form.account.newPassword.length > 7" class="ml-4" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M8.85714 3.5L3.61902 8.5L1 6" stroke="#009918" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
						<svg v-else-if="passwordTooShort" class="ml-4" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.182 8.182 1.818 1.818" stroke="#ED2644" stroke-width="1.5" stroke-linecap="round"/><path d="m1.818 8.182 6.364-6.364" stroke="#ED2644" stroke-width="1.5" stroke-linecap="round"/></svg>
					</small>
				</div>
			</div>
		</div>

		<div v-if="errorMessage.length" class="error-message mt-24">{{ errorMessage[0] }}</div>
		<div class="flex-right gap-16 mt-24">
			<button :disabled="!hasChanges || passwordTooShort" class="btn btn-green save" @click="onSave">Save Changes</button>
		</div>
	</div>
</template>

<script>
import User from '@/models/User';
import form from '@/mixins/form';

export default {
	name: 'AccountInfo',
	mixins: [form],
	data() {
		return {
			form: {
				account: {
					firstName: '',
					lastName: '',
					email: '',
					password: '',
					newPassword: '',
				},
				profile: {
					studioName: '',
				},
			},
			passwordTooShort: false,
			passwordError: null,
			clean: '',
		};
	},
	components: {},
	computed: {
		isStudio() {
			const level = this.$store.getters['subscriptions/currentLevel'];
			return !!level && !level.canBeHired;
		},
		hasChanges() {
			return JSON.stringify(this.form) !== this.clean;
		},
	},
	methods: {
		init() {
			this.form.profile.studioName = this.$activeUser.studioName;
			this.form.account.firstName = this.$activeUser.firstName;
			this.form.account.lastName = this.$activeUser.lastName;
			this.form.account.email = this.$activeUser.email;
			this.form.profile.studioName = this.$activeProfile.studioName;
			this.clean = JSON.stringify(this.form);
		},
		checkPasswordTooShort() {
			this.passwordTooShort = this.form.account.newPassword.length ? this.form.account.newPassword.length < 8 : false;
		},
		async onSave() {
			this.errorMessage = '';
			await this.saveAccount();
			
			if (JSON.parse(this.clean).profile.studioName !== this.form.profile.studioName) {
				this.saveProfile();
			}
		},
		async saveAccount() {
			const { newPassword, password } = this.form.account;
			const payload = User.toPatch({
				firstName: this.form.account.firstName,
				lastName: this.form.account.lastName,
				email: this.form.account.email,
			});

			if (newPassword && password) {
				payload.newPassword = newPassword;
				payload.password = password;
			}

			this.action('users/updateActiveUser', payload);
		},
		async saveProfile() {
			const { studioName } = this.form.profile;
			this.action('profiles/updateActiveProfile', { studioName });
		},
	},
	created() {
		this.init();
	},
	watch: {
		$activeUser() {
			this.init();
		},
		'form.account.newPassword': function(val) {
			if (val.length > 7) {
				this.passwordTooShort = false;
			}
		},
	},
	metaInfo: {
		title: 'Account Information',
	},
};
</script>
